import { useState } from 'react';
import { Spinner } from 'commons/components';
import { STATS_SHIPPING_PAGE } from 'config/upsellFlowSources';
import {
  useStatisticsFilterContext,
  useTranslationStatistics,
} from 'domains/Statistics/hooks';
import { STATS_PLAN_3 } from 'domains/Statistics/utils';
import useGetRevenueByProvince from './useGetRevenueByProvince';
import ChartOrPlaceholder from '../ChartOrPlaceholder';
import DoubleCardResponsive from '../DoubleCardResponsive';
import GenericEmptySearch from '../GenericEmptySearch';
import GenericError from '../GenericError';
import RankByProvinceChart from '../RankByProvinceChart';
import StatisticsProvincesMap from '../StatisticsProvincesMap';

function ShippingRevenueByProvinceCard() {
  const t = useTranslationStatistics();
  const [visible, setVisible] = useState('');
  const {
    fetchRevenueByProvince,
    revenueByProvince,
    isLoading,
    isError,
    isSuccess,
  } = useGetRevenueByProvince();
  const { openFilter } = useStatisticsFilterContext();

  const handleOnMouseOver = (id: string) => {
    setVisible(id);
  };

  const handleOnMouseLeave = () => setVisible('');

  const filtered = visible
    ? revenueByProvince?.coordinates.filter(
        (province) => province.id === visible,
      )
    : revenueByProvince?.coordinates;

  return (
    <DoubleCardResponsive
      title={t('statistics.revenueByProvinceCard.title')}
      left={
        <ChartOrPlaceholder
          type="bars-horizontal"
          statsPlanRequired={STATS_PLAN_3}
          upsellSource={STATS_SHIPPING_PAGE}
        >
          {isLoading && <Spinner size="medium" />}
          {isError && <GenericError onRetry={fetchRevenueByProvince} />}
          {isSuccess && revenueByProvince?.results.length === 0 && (
            <GenericEmptySearch onRetry={openFilter} />
          )}
          {isSuccess &&
            revenueByProvince &&
            revenueByProvince?.results.length > 0 && (
              <RankByProvinceChart
                onMouseOver={handleOnMouseOver}
                onMouseLeave={handleOnMouseLeave}
                provincesRanking={revenueByProvince.results}
              />
            )}
        </ChartOrPlaceholder>
      }
      right={<StatisticsProvincesMap provinces={filtered} />}
    />
  );
}

export default ShippingRevenueByProvinceCard;
